import { render, staticRenderFns } from "./temp_boton.vue?vue&type=template&id=4c4d85da&"
import script from "./temp_boton.vue?vue&type=script&lang=js&"
export * from "./temp_boton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports